import { create } from "zustand";
import type {
  ChildEmotionOption,
  ChildSessionState,
  ChildSessionStep,
  PostEmotionValue,
} from "@/lib/types/exercise/childSession";

export const useChildSessionStore = create<ChildSessionState>((set) => ({
  selectedEmotionId: null,
  selectedEmotion: null,
  currentStep: "animation",
  postEmotion: null,

  selectEmotion: (emotion: ChildEmotionOption) =>
    set({
      selectedEmotionId: emotion.id,
      selectedEmotion: emotion,
      currentStep: "animation",
      postEmotion: null,
    }),

  setStep: (step: ChildSessionStep) => set({ currentStep: step }),

  setPostEmotion: (value: PostEmotionValue) =>
    set({ postEmotion: value, currentStep: "outcome" }),

  reset: () =>
    set({
      selectedEmotionId: null,
      selectedEmotion: null,
      currentStep: "animation",
      postEmotion: null,
    }),
}));
